import React, { useContext } from 'react'
import styled from 'styled-components'
import { Progress } from 'antd'

import { FlexRow } from '../../FlexboxReusables/FlexItems'
import NavigationButtonsRow from './NavigationButtonsRow'
import StartExamModal from './StartExamModal'
import ExamInstructions from '../ExamInstructions/ExamInstructions'
import WelcomeModal from './WelcomeModal'
import { ParticipantCourseContext } from '../Context/ParticipantCourseContext'
import { imageUrl } from '../../../globals'
import ParticipantNavbar from '../../Navigation/ParticipantNavbar'

const DisplayCourseMaterial = () => {
  const {
    basicCourseData,
    coursePages,
    examInfo,
    currentPage,
    courseProgress,
    isExamStarted,
    isStartExamModalVisible,
    displayWelcomeModal,
    hasSetWelcomeModalToNeverShowAgain,
    hasReachedLastPage
  } = useContext(ParticipantCourseContext)

  return (
    <>
      <ParticipantNavbar />
      <FlexRow>
        {!hasReachedLastPage && (
          <StyledProgress
            percent={courseProgress}
            status="active"
            format={() => `${currentPage + 1}/${coursePages.length}`}
          />
        )}
      </FlexRow>
      <FlexRow>
        {coursePages[currentPage]?.previewPictureIsFromPdf && (
          <PdfPageAsImage
            src={`${imageUrl}/${basicCourseData?.courseId}/${currentPage + 1}.jpg` }
            alt='noImage'
          />
        )}
      </FlexRow>
      {isStartExamModalVisible && (
        <StartExamModal />
      )}
      {displayWelcomeModal && !hasSetWelcomeModalToNeverShowAgain && (
        <WelcomeModal />
      )}
      {hasReachedLastPage && examInfo && !isExamStarted &&(
        <ExamInstructions
          examInfo={examInfo}
        />
      )}
      {!isExamStarted && (
        <NavigationButtonsRow />
      )}
    </>
  )
}

export default DisplayCourseMaterial

const StyledProgress = styled(Progress)`
  width: 90%;
`

const PdfPageAsImage = styled.img`
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 2px 4px rgba(234, 225, 225, 0.5);
`
